import { Api } from '../../Api';
import { IServiceHistoryFileGetParams, ISettingsScheduleGetParams } from './';

export class Schedule {
    private static _basePath = '/Schedule';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${Schedule._basePath}`;
        return {
            async setCompleted({ name }: ISettingsScheduleGetParams) {
                const path = `/action/setCompleted/?name=${name}`;
                return await Api.post<boolean>({
                    path: `${basePath}${path}`,
                });
            },
            async start({ name }: ISettingsScheduleGetParams) {
                const path = `/action/start/?name=${name}`;
                return await Api.post<boolean>({
                    path: `${basePath}${path}`,
                });
            },
            async getHistoryFile({ availableReport, date }: IServiceHistoryFileGetParams) {
                const path = `/history/${date}/files/download`;
                return await Api.get<string>({
                    path: `${basePath}${path}`,
                    query: { availableReport },
                });
            },
        };
    }
}
